<template>
  <div class="conditions-box">
    <diV v-show="!isSp" class="conditions-box-shadow">
    </diV>
    <div class="conditions-box-content container">
      <div class="row condition-box-header">
        <div class="col-md-12">
          <i class="fas fa-calendar mr-2"></i><b>アーカイブ</b>
        </div>
        <div class="col-md-12">
          <hr class="condition-box-hr">
        </div>
        <div class="col-md-12 mb-3 mt-1">
          <select :style="selectStyle" class="simple-select" v-model="selectedMonth" @change="changeSelectBox">
            <option value="" disabled selected style="display:none; color: #CDD6DD">月を選択</option>
            <option v-for="month in archiveMonths" :key="month.label" :value="month.value">{{month.label}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { restMethods } from '../mixins/rest_methods'
export default {
  data() {
    return {
      archiveMonths: [],
      selectedMonth: ""
    }
  },
  props: {
    oldReleasedAt: {
      type: String,
      default: ""
    },
    isSp:{
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  methods: {
    getParam(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    changeSelectBox(){
      location.href=`/articles?month=${this.selectedMonth}`
    }
  },
  created(){
    const lastDate = new Date(this.oldReleasedAt);
    const today = new Date();
    let targetDate = new Date(lastDate.setDate(1));
    while(targetDate < today){
      this.archiveMonths.unshift({
        label: `${targetDate.getFullYear()}年${targetDate.getMonth()+1}月`,
        value: `${targetDate.getFullYear()}-${targetDate.getMonth()+1}`
      })
      targetDate.setMonth(targetDate.getMonth()+1);
    }
    const dateFromUrl = this.getParam("q[updated_at_gteq]");
    if(dateFromUrl){
      const selectedDate = new Date(dateFromUrl);
      this.selectedMonth = `${selectedDate.getFullYear()}-${selectedDate.getMonth()+1}`
    }
  },
  computed: {
    selectStyle(){
      if(this.selectedMonth != ""){
        return "color: #263238;"
      }
      else{
        return "color: #CDD6DD;"
      }
    }
  },
  watch: {
  }
}
</script>